import PolarisIcon from '@/components/_common/PolarisIcon';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { Chip, ChipProps, Palette, Typography } from '@mui/material';

const iconNames = {
  video: 'video',
  audio: 'volume',
  subtitle: 'subtitle',
  'dub card': 'subtitle',
  'timed text': 'subtitle',
  image: 'image',
  other: 'unknown',
  'media support': 'file'
};

const chipColor: Record<string, keyof Palette> = {
  video: 'primary',
  audio: 'secondary',
  subtitle: 'default',
  image: 'tertiary',
  'timed text': 'default',
  other: 'default'
};

const chipTextColor: Record<string, keyof Palette> = {
  video: 'primary',
  audio: 'secondary',
  image: 'tertiary'
};

type FileTypeDisplayProps = ChipProps & {
  type: string;
  small?: boolean;
  chip?: boolean;
};

//TODO Kyle: This should be updated to use accept a dict of lables, icons, values, colors and fall back to defaults if not provided
const FileTypeDisplay = ({ chip = true, type, small = false, ...chipProps }: FileTypeDisplayProps) => {
  if (!type) return null;
  const theme = useTheme();
  const padding = 5;
  const iconSize = small ? 14 : 16;
  const iconType = type.toLocaleLowerCase();
  const color = (chipColor[iconType as keyof typeof chipColor] || 'default') as ChipProps['color'];

  if (!chip) {
    return (
      <PlainContainer color={theme.palette[color as keyof Palette].main} className={chipProps?.className}>
        <PolarisIcon
          icon={iconNames[iconType as keyof typeof iconNames]}
          height={small ? 14 : 23}
          width={small ? 14 : 25 + padding}
          style={{ paddingLeft: padding }}
        />
        <Typography color={color} component="span" fontSize={small ? '0.8rem' : '1.2rem'} textTransform="capitalize">
          {type}
        </Typography>
      </PlainContainer>
    );
  }

  return (
    <StyledChip
      label={<span style={{ paddingRight: padding }}>{type.toUpperCase()}</span>}
      icon={
        <PolarisIcon
          icon={iconNames[iconType as keyof typeof iconNames]}
          height={iconSize}
          width={iconSize + padding}
          style={{ paddingLeft: padding }}
        />
      }
      color={chipTextColor[iconType as keyof typeof chipColor] as ChipProps['color']}
      small={+small}
      {...chipProps}
    />
  );
};

export default FileTypeDisplay;

const PlainContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.color};

  span {
    margin-left: ${(props) => props.theme.spacing(1)};
  }
`;

const StyledChip = styled(Chip)<{ small: number; color?: ChipProps['color'] }>`
  line-height: 1;
  white-space: nowrap;
  font-size: ${({ small }) => (small ? '0.8rem' : '.95rem')};
  height: ${({ small }) => (small ? '25px' : '30px')};
  ${({ theme, color }) =>
    color
      ? `
    color: ${theme.palette.common.white};
  `
      : null};
`;
